
import store from "/store/index";

const HT = 1;
const RK = 2;
const CK = 3;
const AZ = 4;
const SH = 5;

const outMenuEnum = [
  {
    code: HT,
    name: "管理后台",
    text: "管理后台",
    url: "/houTai"
  },
   {
     code: RK,
     name: "扫码入库",
     text: "操作入库",
     url: "/ruKu"
   },
  {
    code: CK,
    name: "扫码出库",
    text: "操作出库",
    url: "/chuKu"
  },
  {
    code: AZ,
    name: "安装登记",
    text: "操作安装",
    url: "/anZhuangOneForOne"
  },
  {
    code: SH,
    name: "售后登记",
    text: "售后登记",
    url: "/shouHou"
  }
];

/**
 * 根据code获取对象
 */
outMenuEnum.getInfo = code => {
  let filter = outMenuEnum.filter(item => item.code == code);
  if (filter && filter.length == 1) {
    return filter[0];
  } else {
    console.log('匹配异常', code, filter, filter);
    return '未知';
  }
};

outMenuEnum.HT = HT;
outMenuEnum.RK = RK;
outMenuEnum.CK = CK;
outMenuEnum.AZ = AZ;
outMenuEnum.SH = SH;
outMenuEnum.outMenuEnum = outMenuEnum;
outMenuEnum.outMenu = (p, c) => {
  const h = p.$createElement;
  let list = outMenuEnum.filter(item => {
    let permissionInfo = store.getters.permissionInfo;
    return item.name != c && permissionInfo.indexOf(item.text) >= 0
  });
  //if (list.length == 1) {
  // p.$router.push(list[0].url);//直接跳转到对应页面
  //} else {
  //  let houTai = outMenuEnum.getInfo(outMenuEnum.HT);
  //  if (list.length == 0) {
  //    p.$router.push(houTai.url);//直接跳转到对应页面
  //  } else {
      let houTai = outMenuEnum.getInfo(outMenuEnum.HT);
      list.push(houTai);//其他情况添加后台管理菜单
      p.$msgbox({
        customClass: "caidan",
        title: p.$store.getters.adminName,
        message: h('rk-cd', {
          props: {
            list: list,
          },
          on: {
            goTo: url => {
              p.$router.push(url);
              p.$msgbox.close();
            }
          }
        }),
        center: true,
        showConfirmButton: false
      });
  //  }
  //}
};

export { outMenuEnum };



// WEBPACK FOOTER //
// ./src/util/outMenuEnum.js